<div class="wrapper mb-5">
    <div class="row" style="padding: 10px;">
        <div class="col-md-3 col-sm-12 p-0 title-container align-items-center">
            <img src="./assets/icons/arrow.svg">
            <span class="label-title ml-2 mr-3"> Novo pedido</span>
        </div>
        <!--navegação-->
        <div class="col-md-9 col-sm-12 p-0">
            <div class="row container-fluid menu-navegacao-borda m-0 bg-white">
                <div class="menu-navegacao-espacamento col d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto select">PRODUTOS</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto select">FAVORECIDOS</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto">CRÉDITO</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto">CONFIRMAÇÃO</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto">PAGAMENTO</span>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="nav nav-tabs mt-4" id="nav-tab" role="tablist">
        <ng-container *ngIf="collaboratorType">
            <ng-container *ngFor="let item of collaboratorType">
                <a class="nav-item nav-link" [ngClass]="{'active': item.collaboratorTypeId == 1}" id="nav-{{item.collaboratorType}}-tab" data-toggle="tab" href="#nav-{{item.collaboratorType}}" role="tab" attr.aria-controls="nav-{{item.collaboratorType}}" aria-selected="false" (click)="tipocolaborador(item.collaboratorTypeId)">
                    {{item.collaboratorType}}
                </a>
            </ng-container>
        </ng-container>
    </div> -->
    <div class="component-box container-fluid mt-5 p-5">
        <!--opções-->
        <div class="row container-fluid text-center type-tabs">
            <div *ngFor="let item of opcoesArquivo" class="col-6 clickable purchaseTab"
                (click)="setOpcaoPedidoArquivo(item)"
                [ngClass]="opcaoArquivoSelecionado === item ? 'btm custom-button-pedido selecionado' : 'btm custom-button-pedido' ">
                {{item.nome}}
            </div>
        </div>
        <div class="container-fluid mt-3">
            <div [hidden]="opcaoArquivoSelecionado?.Id !== 2" class="">
                <div class="col-12 px-0 mb-4">
                    <div class="row container-fluid mx-0 px-0 justify-content-center">
                        <div id="tabela" class="mt-3" style="overflow: auto;"></div>
                    </div>
                </div>
            </div>
            <!--resto-->
            <div [hidden]="opcaoArquivoSelecionado?.Id === 2" class="row mt-5 mb-4">
                <div class="col-4">
                    <app-upload-arquivo [accept]="accept" subtitle="Ultilize formato CSV" (file)="setFile($event)"></app-upload-arquivo>
                </div>
                <div *ngIf="opcaoArquivoSelecionado?.urlArquivoExemplo" class="col-8 center justify-content-start">
                    <span class="black"><a class="simple" download="template-recarga.csv" [href]="download">Clique aqui</a> para baixar nosso template da recarga.</span>
                    <i class="fas fa-info-circle info-icon-background popover-content pl-1" style="cursor: pointer;" [ngbPopover]="popContent" triggers="mouseenter:mouseleave" aria-hidden="true"></i>
                </div>
            </div>
            <p class="clean-text m-0" style="font-size: small;">
                * Para realizar a recarga é obrigatório o preenchimento de no minimo um do campos (CPF ou Telefone).<br>
                <!-- ** Campos obrigatórios para o cadastro automático, caso um {{ collaboratorType[tipoColaborador-1].collaboratorType }} não exista na cedente. -->
            </p>
            <!-- <div class="form-check-inline text-center col my-2" *ngIf="!this.flexIndividual && this.grupo?.id">
                <input #autoAddColab id="autoAddColab" class="radio-checkbox mx-2" type="checkbox" (change)="onAutoAddColabChanged(autoAddColab.checked)" />
                <label for="autoAddColab" class="form-check-label">
                    Incluir favorecido(s) no grupo caso não pertença a ele
                </label>
            </div> -->
            <div class="col-12 text-right button-container mt-5 mb-3">
                <button type="button" class="custom-button-full" (click)="continuar()">
                    CONTINUAR
                </button>
            </div>
        </div>
    </div>
</div>
<!--div class="container-fluid mb-5">
    <div class="row">
        <div class="col-md-5 col-sm-12 text-left mb-5">
            <span class="list-header-title">Novo pedido</span>
        </div>
        <--navegação->
        <div class="col-md-7 col-sm-12 mb-5 p-0">
            <div class="row container-fluid menu-navegacao-borda m-0 bg-white">
                <div class="menu-navegacao-espacamento col d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto select">PRODUTOS</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto" [ngClass]="pedidos? 'select': ''">BENEFICIÁRIOS</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto">CRÉDITO</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto">CONFIRMAÇÃO</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto">PAGAMENTO</span>
                </div>
            </div>
        </div>
        <div class="form-box container-fluid bg-white">
            <div class="col-12">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 text-left form-title mt-5 mb-1">
                            <p class="form-title">OPÇÕES</p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 text-left form-title mt-1 mb-4">
                            <!-opções->
                            <div *ngFor="let item of opcoesArquivo" class="btn-group mr-4 mb-2" role="group">
                                <button (click)="setOpcaoPedidoArquivo(item)"
                                    [ngClass]="opcaoArquivoSelecionado === item ? 'btm custom-button-pedido selecionado' : 'btm custom-button-pedido' ">
                                    {{item.nome}}
                                </button>
                            </div>

                            <!-special Bankei Tabela->
                            <div [hidden]="opcaoArquivoSelecionado?.Id !== 2" class="">
                                <div class="col-12 px-0 mb-4">
                                    <div class="row container-fluid mx-0 px-0 justify-content-center">
                                        <div id="tabela" class="mt-3" style="overflow: auto;"></div>
                                    </div>
                                </div>
                            </div>
                            <!-resto->
                            <div [hidden]="opcaoArquivoSelecionado?.Id === 2" class="row mt-3">
                                <div class="col-4">
                                    <app-upload-arquivo [accept]="accept" (file)="setFile($event)"></app-upload-arquivo>
                                </div>
                                <div *ngIf="opcaoArquivoSelecionado?.urlArquivoExemplo" class="col-2 center">
                                    <span class="black">Você pode baixar o nosso <a class="simple" download="Template.csv" [href]="download">template</a></span>
                                </div>
                            </div>


                            <div class="col-12 text-right button-container mt-5 mb-3">
                                <button type="button" class="custom-button-full" (click)="continuar()">
                                    CONTINUAR
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!- <app-novo-pedido-arquivo-confirmar *ngIf="false" style="width: 100%"></app-novo-pedido-arquivo-confirmar> ->
    </div>
</div-->

<ng-template #popContent>
    Dica: Após baixar o template, abra-o no excel utilizando a opção importar, se necessário, informe o separador ';' para apresentar as colunas.
    <br><br>
    O template somente será processado se todos os registros estiverem aptos para serem importados.
</ng-template>
